import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Grid } from "swiper/modules";

import JobCard from "./JobCard";

function JobList({ list, prevID, nextID }) {
    return (
        <Swiper
            spaceBetween={10}
            // loop={true}
            // autoplay={{
            //     delay: 2000,
            //     disableOnInteraction: false,
            // }}
            breakpoints={{
                0: {
                    slidesPerView: 1,
                    grid: { rows: 1, fill: 'row' }
                },
                640: {
                    slidesPerView: 1,
                    grid: { rows: 1, fill: 'row' }
                },
                768: {
                    slidesPerView: 2,
                    grid: { rows: 2, fill: 'row' }
                },
                1024: {
                    slidesPerView: 3,
                    grid: { rows: 2, fill: 'row' }
                },
            }}
            navigation={{
                prevEl: `#${prevID}`,
                nextEl: `#${nextID}`
            }}
            modules={[Grid, Navigation, Autoplay]}
        >
            {list.map((item, index) => (
                <SwiperSlide key={index} className="h-full">
                    <JobCard
                        title={item.title}
                        company={item.company}
                        location={item.location}
                        salary={item.salary}
                        daysLeft={item.daysLeft}
                        image={item.image}
                    />
                </SwiperSlide>
            ))}
        </Swiper>
    );
}

export default JobList;